import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../images/dashboard/logo.png';

const AdminHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const headerIdentity =
        (localStorage.getItem('loginName') || '').trim() ||
        (localStorage.getItem('loginEmail') || '').trim() ||
        (localStorage.getItem('loginMobile') || '').trim();

    const menuItems = [
        { label: 'Orders', path: '/dashboard' },
        { label: 'Home', path: '/' },
        { label: 'Image Upload', path: '/imageupload' },
        // { label: 'Add Offer', path: '/offerupdate' },
        { label: 'All Colors', path: '/updateColors' },
        { label: 'Charts', path: '/charts' },
        // { label: 'All Products', path: '/updateProducts' },
        { label: 'Manage', path: '/manageProducts' },
    ];

    const isActive = (path) => location.pathname.toLowerCase() === path.toLowerCase();

    return (
        <div className='sticky bg-white z-[100] top-0 w-full lg:px-12 px-3 lg:py-5 py-3 flex lg:justify-between justify-center items-center border-b border-gray-200 shadow-sm'>
            <img
                src={logo}
                alt="logo"
                className='w-[120px] h-auto cursor-pointer lg:flex hidden hover:opacity-80 transition-opacity'
                onClick={() => navigate('/')}
            />

            <div className='flex flex-row lg:gap-8 gap-4 overflow-x-auto no-scrollbar'>
                {menuItems.map((item) => (
                    <span
                        key={item.path}
                        className={`lg:text-sm text-xs font-bold font-montserrat uppercase tracking-widest cursor-pointer transition-all duration-200 text-nowrap
                            ${isActive(item.path)
                                ? 'text-black border-b-2 border-black pb-1'
                                : 'text-gray-400 hover:text-black'}`}
                        onClick={() => navigate(item.path)}
                    >
                        {item.label}
                    </span>
                ))}
            </div>

            <div className='lg:flex hidden items-center'>
                {headerIdentity && (
                    <span className='text-xs font-bold font-montserrat uppercase tracking-widest text-gray-500'>
                        {headerIdentity}
                    </span>
                )}
            </div>
        </div>
    );
};

export default AdminHeader;
